import api from './api';

/**
 * Serviço para gerenciamento de logs de auditoria
 */
const auditService = {
  // Listar logs de auditoria com paginação
  getAuditLogs: async (params = {}) => {
    try {
      const response = await api.get('/audit', { params });
      return response.data;
    } catch (error) {
      console.error('Erro ao buscar logs de auditoria:', error);
      throw error;
    }
  },

  // Listar ações e recursos disponíveis
  getAuditActions: async () => {
    try {
      const response = await api.get('/audit/actions');
      return response.data;
    } catch (error) {
      console.error('Erro ao buscar ações de auditoria:', error);
      throw error;
    }
  },

  // Estatísticas de auditoria
  getAuditStats: async () => {
    try {
      const response = await api.get('/audit/stats');
      return response.data;
    } catch (error) {
      console.error('Erro ao buscar estatísticas de auditoria:', error);
      throw error;
    }
  },

  // Buscar log específico
  getAuditLogById: async (id) => {
    try {
      const response = await api.get(`/audit/${id}`);
      return response.data;
    } catch (error) {
      console.error('Erro ao buscar log de auditoria:', error);
      throw error;
    }
  },

  // Excluir múltiplos levantamentos em massa
  deleteMultipleSurveys: async (ids) => {
    try {
      const response = await api.post('/surveys/delete-mass', { ids });
      return response.data;
    } catch (error) {
      console.error('Erro ao excluir levantamentos em massa:', error);
      throw error;
    }
  }
};

export default auditService;